import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"
import { CompleteHeader, Cell } from "@tenforce/toolbox-table-react"

import { Labels } from "../../../../util/Translations"

export const TableHeader = (): JSX.Element => {
    const { Name, Description, ExportPackage } = Labels

    const columns = [Name, Description, ExportPackage]

    return (
        <CompleteHeader headerRowProps={{ isCondensed: true }}>
            {columns.map(
                (column, index): JSX.Element => (
                    <Cell key={index}>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={column}
                            >
                                {column}
                            </Action>
                        </div>
                    </Cell>
                ),
            )}
        </CompleteHeader>
    )
}

export default TableHeader
